import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteMerchant } from 'Services';
import { RQ_MERCHANT_OVERRIDES, RQ_SINGLE_MERCHANT } from 'Utils';
import useAlertBanner from 'Hooks/reduxHelperHooks/useAlertBanner';
import { useTranslation } from 'react-i18next';
import { trackEvent, EventTypes, EventNames } from '@brighterion/insights';
import useSingleMerchantErrorHandler from './useSingleMerchantErrorHandler';

function useDeleteSingleMerchant(merchantId: string | null, templateRepositoryId: number | null) {
    const queryClient = useQueryClient();
    const { addAlert } = useAlertBanner();
    const { t } = useTranslation();
    const errorHandler = useSingleMerchantErrorHandler();
    return useMutation([RQ_SINGLE_MERCHANT, merchantId], () => deleteMerchant(merchantId!, templateRepositoryId!), {
        onSuccess: () => {
            const content = t('delete single merchant success msg', { merchantId });
            addAlert({
                id: 'delete-single-merchant-success',
                content,
                status: 'success'
            });
            trackEvent({
                eventType: EventTypes.track,
                eventName: EventNames.click,
                payload: {
                    clickIdentifier: 'Subjects - Delete Subject',
                    text: 'Delete Subject'
                }
            });
        },
        onError: errorHandler,
        onSettled: () => {
            queryClient.invalidateQueries([RQ_MERCHANT_OVERRIDES]);
        }
    });
}

export default useDeleteSingleMerchant;
